const StationList = () => import('Views/station/station-list');
const StationAddEdit = () => import('Views/station/station-addEdit');
const StationDetail = () => import('Views/station/station-detail');
const StationPushApiAddEdit = () => import('Views/station/station-push-api-addEdit');

export default[
  { path: '/station-list', component: StationList },
  { path: '/station-add', component: StationAddEdit },
  { path: '/station-edit/:id', component: StationAddEdit },
  { path: '/station-detail/:id', component: StationDetail },
  { path: '/station-push-api-edit/:id', component: StationPushApiAddEdit },
];



// WEBPACK FOOTER //
// ./src/router/station.js